'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { GridLayout, GridTemplateAreas, GridVariables } from '@styles/GridVariables';

export const Grid = styled.div`
  ${GridVariables};

  display: grid;
  grid-template-areas: ${GridTemplateAreas.mobile};
  grid-template-columns: ${GridLayout.mobile.columns};
  gap: ${GridLayout.mobile.gap};
  margin-inline: var(--mobile-gutter);
  margin-top: var(--desktop-gutter);

  ${breakpoints.desktopOrBigger} {
    grid-template-columns: ${GridLayout.desktop.columns};
    gap: ${GridLayout.desktop.gap};
    grid-template-areas: ${GridTemplateAreas.desktop};
    margin: 0;
  }

  // Makes the grid container take up full height when any of its children
  // has the 'full-height' class. This is useful for layouts that need to
  // stretch to fill the entire viewport height, and
  // allows the grid container to dynamically adjust its height based on its content

  &:has(.auth-page) {
    min-height: 100%;
    ${breakpoints.desktopOrBigger} {
      grid-template-columns: ${GridLayout.authDesktop.columns};
      gap: ${GridLayout.authDesktop.gap};
      grid-template-areas: ${GridTemplateAreas.desktopAuth};
      margin: 0;
    }
  }

  &:has(.full-height) {
    height: 100%;
  }
`;
